import { render } from "./lesson-plan.vue?vue&type=template&id=2cde4c6c&ts=true"
import script from "./lesson-plan.vue?vue&type=script&lang=ts"
export * from "./lesson-plan.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__